import type { TemplateResponseDTO } from '@conversed/rest/src/contracts/template-response/template-response.dto';
import { mainActions } from '@store/reducers/mainHandler';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useMainSelector } from '../../useMainSelector';

export const useTemplateResponses = () => {
  const {
    templateResponses: { templates, selectedTemplate },
  } = useMainSelector();
  const dispatch = useDispatch();

  const setSelectedTemplateResponse = useCallback(
    (templateResponse: TemplateResponseDTO) => {
      dispatch(mainActions.setSelectedTemplateResponse(templateResponse));
    },
    [dispatch],
  );

  return {
    templateResponses: templates,
    selectedTemplateResponse: selectedTemplate,
    setSelectedTemplateResponse,
  };
};
